import { TAGButton, TAGLink } from '@aspendental/shared-components-web';
import LanguageToggle from '@aspendental/shared-components-web/lib/components/LanguageToggle/LanguageToggle';
import { Logout } from '@mui/icons-material';
import { Box, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ASPEN_DENTAL_LOGO_LIGHT, FORMS_BASE_URL, PATIENT_SERVICES_BASE_URL } from '@src/constants';
import { useFacilityId } from '@src/hooks/patient-services/useFacilityId';
import { getCookie } from '@src/pages/utils/get-cookie';
import { useAppStore } from '@src/store';
import { displayNavigation } from '@src/utils/display-navigation';
import Hamburger from 'hamburger-react';
import { useRouter } from 'next/router';
import { Dispatch, SetStateAction } from 'react';
import { desktopLogoContainer, formsHeaderActions, hamburgerStyles, headerContainer, headerSpacer, headerStyles, logoutIcon, mobileHeaderStyles, mobileLogo, mobileLogoContainer, signoutButton } from './PatientServicesHeader.styles';
export default function PatientServicesHeader({
  setPatientServicesNavMenu,
  logout
}: {
  setPatientServicesNavMenu?: Dispatch<SetStateAction<boolean>>;
  logout: () => Promise<void>;
}) {
  const theme = useTheme();
  const router = useRouter();
  const {
    pathname
  } = router;
  const isLargeDevice = useMediaQuery(theme.breakpoints.up('md'));
  const isOneClickLogin = getCookie('isOneClickLogin') || router.query.token;
  const isOnForms = pathname.includes(FORMS_BASE_URL);
  const {
    facilityId
  } = useFacilityId();
  const isAuthRoute = pathname.includes('authentication');
  const logoHref = isOneClickLogin || isAuthRoute ? `/${PATIENT_SERVICES_BASE_URL}/` : `/${PATIENT_SERVICES_BASE_URL}/appointment/`;
  const enableNavigation = useAppStore(store => store.isPatientPortalNavigationEnabled);
  const enableFormsLanguageToggle = useAppStore(store => store.officeRollout?.enableFormsLanguageToggle?.includes(facilityId) ?? false);
  return <Box sx={headerContainer} id="site-header" data-test-id="section_header" data-sentry-element="Box" data-sentry-component="PatientServicesHeader" data-sentry-source-file="PatientServicesHeader.tsx">
			{isLargeDevice ? <Box sx={headerStyles(isOnForms)}>
					{isOnForms && <Box sx={headerSpacer}></Box>}
					<Box sx={desktopLogoContainer}>
						<TAGLink href={logoHref} data-test-id="link_logo">
							<Box component="img" src={ASPEN_DENTAL_LOGO_LIGHT} width="12.5rem" height="unset" data-test-id="img_logo_desktop" alt="brand logo"></Box>
						</TAGLink>
					</Box>
					{isOnForms && <Box sx={formsHeaderActions(isLargeDevice)}>
							{enableFormsLanguageToggle && <LanguageToggle isLargeDevice={isLargeDevice} isDarkHeader />}
							<TAGButton sx={signoutButton(isLargeDevice)} onClick={logout}>
								<Logout sx={logoutIcon} />
								<Typography color="white" variant="bodyMediumBold">
									Sign out
								</Typography>
							</TAGButton>
						</Box>}
				</Box> : <Box sx={mobileHeaderStyles}>
					{enableNavigation && displayNavigation(pathname, isOneClickLogin, router.query.returnTo) && setPatientServicesNavMenu && <Box sx={hamburgerStyles}>
								<IconButton onClick={() => setPatientServicesNavMenu(true)} data-test-id="button_hamburger" tabIndex={-1}>
									<Hamburger toggled={false} size={24} color={theme.palette.text.light} label="open-menu" />
								</IconButton>
							</Box>}

					<Box sx={mobileLogoContainer(isOnForms)}>
						<TAGLink href={logoHref} data-test-id="link_logo">
							<Box component="img" src={ASPEN_DENTAL_LOGO_LIGHT} width="7.25rem" height="auto" data-test-id="img_logo_mobile" alt="brand logo" sx={mobileLogo} />
						</TAGLink>
					</Box>
					{isOnForms && <Box sx={formsHeaderActions(isLargeDevice)}>
							{enableFormsLanguageToggle && <LanguageToggle isLargeDevice={isLargeDevice} isDarkHeader />}
							<TAGButton sx={signoutButton(isLargeDevice)} onClick={logout}>
								<Logout sx={logoutIcon} />
								<Typography color="white" variant="bodyMediumBold">
									Sign out
								</Typography>
							</TAGButton>
						</Box>}
				</Box>}
		</Box>;
}